import React, { useCallback, useEffect, useState } from "react";
import { Container } from "reactstrap";
import { useParams } from "react-router-dom";
import PageLoadingSpinner from "components/common/PageLoader";
import BreadCrumb from "components/common/BreadCrumb";
import { getDocumentTitle } from "utils/helpers";
import { getPettyWork } from "features/PettyWorks/services/PettyWorkService";
import type { PettyWork } from "features/PettyWorks/types/petty-work.types";
import PettyWorkOverviewContext from "./PettyWorkOverviewContext";
import Section from "./Section";

const PettyWorkOverview = () => {
  document.title = getDocumentTitle("Petty Work Details");
  const { id } = useParams();
  const [pettyWork, setPettyWork] = useState<PettyWork | null>(null);
  const [loading, setLoading] = useState(true);

  const loadPettyWork = useCallback(async () => {
    if (!id) {
      setPettyWork(null);
      setLoading(false);
      return;
    }
    const numericId = Number(id);
    setLoading(true);
    try {
      const res = await getPettyWork(numericId);
      if (res.success) {
        setPettyWork(res.data);
      } else {
        setPettyWork(null);
      }
    } catch (err) {
      console.warn(err);
      setPettyWork(null);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    void loadPettyWork();
  }, [loadPettyWork]);

  if (loading) return <PageLoadingSpinner message="Loading petty work..." />;

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="Petty Work Details"
          pageTitle="Petty Works"
          items={[{ label: "Petty Works", path: "/petty-works" }]}
        />
        <PettyWorkOverviewContext.Provider
          value={{ pettyWork, refetch: loadPettyWork }}
        >
          <Section />
        </PettyWorkOverviewContext.Provider>
      </Container>
    </div>
  );
};

export default PettyWorkOverview;
